import React, { useState } from 'react';

function ChipsDemoComponent() {
  const [tags, setTags] = useState(['Office: Vienna', 'Status: Active', 'Type: Retail']);
  return (
    <div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Info chips</div>
        <span className='chip'>
          Client: <b>Demo Client Kft.</b>
        </span>
        <span className='chip'>
          <b>42</b> evaluations
        </span>
        <div className='count-pill'>
          <b>128</b> items
        </div>
      </div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Removable tags (click x to remove)</div>
        {tags.map((tag) => (
          <span
            key={tag}
            className='chip'
          >
            {tag}{' '}
            <button
              type='button'
              className='icon-btn'
              style={{ width: 20, height: 20, minWidth: 0 }}
              onClick={() => setTags(tags.filter((t) => t !== tag))}
            >
              <i className='fa-solid fa-xmark' />
            </button>
          </span>
        ))}
        {tags.length === 0 ? (
          <button
            type='button'
            className='btn ghost sm'
            onClick={() => setTags(['Office: Vienna', 'Status: Active', 'Type: Retail'])}
          >
            Reset tags
          </button>
        ) : null}
      </div>
    </div>
  );
}

export const chipsDemo = {
  id: 'chips',
  title: 'Chips & count pills',
  category: 'Basics',
  importPath: 'src/Css/design-system/bravo-ds.css (.chip / .count-pill / .fcount)',
  notes: [
    '.chip is the pill-shaped inline tag; <b> inside gets navy emphasis.',
    '.count-pill shows result counts in list-page context strips.',
    '.fcount is the small red numeric badge used on the Filters button.',
  ],
  snippet: "<span className='chip'>Client: <b>{clientName}</b></span>",
  render: ChipsDemoComponent,
};
